import { makeStyles } from "@material-ui/styles";
import { theme } from "./theme";
import { stepTitle, descriptionText, link, iconContainer } from "./sharedStyles";

export const useStyles = makeStyles({
  container: {
    padding: "0 0 0 1.56rem",
  },
  radioDescription: {
    ...descriptionText,
    paddingTop: "1rem",
    "& strong": {
      fontWeight: 700,
    },
  },
  configSection: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  step: {
    display: "flex",
    flexDirection: "column",
  },
  stepSubtitle: {
    fontSize: theme.fontSizes.sm,
    margin: 0,
  },
  inputGroup: {
    marginTop: "1rem",
    maxWidth: "400px",
  },
  copySection: {
    marginTop: "1rem",
    display: "flex",
    alignItems: "flex-end",
    gap: "1.5rem",
    justifyContent: "space-between",
  },
  emailDisplay: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  emailText: {
    display: "flex",
    flexDirection: "column",
    "& label": { ...descriptionText, fontWeight: 700 },
    "& span": { fontSize: theme.fontSizes.md, color: theme.text.primary },
  },
  copyButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.text.muted,
  },
  alertContainer: {
    marginTop: "1rem",
  },
  pendingBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "0.5rem",
  },
  pendingActions: {
    display: "flex",
    gap: "0.75rem",
  },
  pendingHint: {
    fontSize: theme.fontSizes.sm,
    color: theme.text.muted,
    textAlign: "right",
  },
  emailContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  stepTitle: { ...stepTitle },
  link: { ...link, fontSize: theme.fontSizes.sm },
  linkAction: { ...link, fontSize: theme.fontSizes.sm },
  iconContainer: { ...iconContainer },
});